import gql from 'graphql-tag';

export default gql`
  mutation createCard($input: CreateCardInput!) {
    createCard(input: $input) {
      id
    }
  }
`;
